// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"29134603","159":"6b5efa9e","348":"2521cd31","641":"6ede91c1"}[chunkId] + ".chunk.js";
};